import { useEffect, useState } from "react";

export const LARGE_FONT_KEY = "pb_large_font";

export const isLargeFont = () => localStorage.getItem(LARGE_FONT_KEY) === "on";

export const setLargeFont = (on) => {
  localStorage.setItem(LARGE_FONT_KEY, on ? "on" : "off");
  window.dispatchEvent(new Event("pb-prefs"));
};

/** Large Font mode — a roomier Day view for users with weaker eyesight. */
export const useLargeFont = () => {
  const [big, setBig] = useState(isLargeFont);
  useEffect(() => {
    const sync = () => setBig(isLargeFont());
    window.addEventListener("pb-prefs", sync);
    return () => window.removeEventListener("pb-prefs", sync);
  }, []);
  return big;
};
